import { InvoiceResponseViewModel } from 'types/invoice';
import { TableFiltersState, TableParams } from 'types/common';

export type InvoicesTableParams = TableParams & Pick<TableFiltersState, 'from' | 'to' | 'activeStatus'>;

export type State = {
    isLoading: boolean;
    list: InvoiceResponseViewModel[];
    tableParams: InvoicesTableParams;
    totalCount: number;
};

export const tableColumns = [
    {
        id: '1',
        field: 'isActive',
        label: 'Active',
    },
    {
        id: '2',
        field: 'title',
        label: 'Title',
    },
    {
        id: '3',
        field: 'total',
        label: 'Total',
    },
    {
        id: '4',
        field: 'createdDate',
        label: 'Created',
    },
    {
        id: '5',
        field: 'expirationDate',
        label: 'Expired',
    },
];

export const initialInvoicesTableParams: TableParams = {
    sortOrder: 'asc',
    orderBy: tableColumns[0].field,
    page: 0,
    pageSize: 5,
    search: undefined,
};

export const initialState: State = {
    isLoading: true,
    list: [],
    tableParams: { ...initialInvoicesTableParams, from: '', to: '', activeStatus: true },
    totalCount: 0,
};
